import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

@Injectable({
    providedIn: 'root'
})
export class Auth0GuardService implements CanActivate {

    constructor(
        private auth0Guard: AuthGuard
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
         return this.auth0Guard.canActivate(route, state);  
    }
}